export default class PersistantStorage<T>
{
  private readonly key: string;
  
  constructor(key: string)
  {
    this.key = key;
  }
  
  public get(): T | undefined
  {
    const json = sessionStorage.getItem(this.key);
    
    if (json === null)
    {
      return undefined;
    }
    
    return JSON.parse(json);
  }
  
  public set(value: T): void
  {
    sessionStorage.setItem(this.key, JSON.stringify(value));
  }
  
  public clear(): void
  {
    sessionStorage.removeItem(this.key);
  }
}